<template>
  <div id="calendar" class="sav-wrapper">
    <Spinner v-if="isLoading"/>
    <Topbar/>
    <div class="sav-container">
      <Header title="Ημερολόγιο Ασφαλειών"/>

			<div class="sav-calendar-search">
				<div class="flex flex-wrap">
					<div class="input-container">
						<h3>Μήνας</h3>
						<select v-model="selectedMonth">
							<option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
						</select>
					</div>
					<div class="input-container">
						<h3>Έτος</h3>
						<select v-model="selectedYear">
							<option v-for="year in 30"  :key="year + startYear" :value="year + startYear">{{ year + startYear }}</option>
						</select>
					</div>
					<div class="input-container">
						<h3>Τύπος</h3>
						<div class="flex flex-4">
							<div class="input-radio-container ">
								<label class="flex flex-align-items-center" for="updates-past">Ενημερώσεις</label>
								<input class="flex flex-justify-content-end" type="radio" id="updates-past" name="gender" value="updates-past" v-model="type">
							</div>
							<div class="input-radio-container ">
								<label class="flex flex-align-items-center" for="updates-future">Ανανεώσεις</label>
								<input class="flex flex-justify-content-end" type="radio" id="updates-future" name="gender" value="updates-future" v-model="type">
							</div>
							<div class="input-radio-container ">
								<label class="flex flex-align-items-center" for="expired">Ληγμένα</label>
								<input class="flex flex-justify-content-end" type="radio" id="expired" name="gender" value="expired" v-model="type">
							</div>
						</div>
					</div>
				</div>
				<div class="sav-calendar-search-footer">
					<div v-if="errorMsg" id="error-msg" class="flex flex-align-items-center">
						<b>{{ errorMsg }}</b>
					</div>
					<div v-if="resultNum" id="results-num-msg" class="flex flex-align-items-end">
						<b>{{ resultNum }}</b>
					</div>
					<button @click="getInsurances" type="submit" class="sav-btn sav-btn-red">Αναζήτηση</button>
				</div>
			</div>

			<hr v-if="tableRows">

      <Table v-if="tableRows" category="calendar" :tableHeaders="tableHeaders" :tableRows="tableRows"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'
import Topbar from './Topbar.vue'
import Header from './Header.vue'
import Table from './Table.vue'
import overviewHeaders from './../../public/data/db.overview-headers.json'

export default {
  components: {
    Spinner,
    Topbar,
    Header,
    Table
  },
  data() {
    return {
      isLoading: false,
      apiUrl : this.$parent.apiUrl,
			months: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
			selectedMonth: new Date().getMonth(),
			startYear: 2015,
			selectedYear: new Date().getFullYear(),
			type: "updates",
      tableHeaders: overviewHeaders,
      tableRows: '',
			errorMsg: '',
			resultNum: ''
    }
  },
  methods: {
    getResultHeader (length) {
      return length > 1 ? "Βρέθηκαν " + length + " ασφάλειες." :  "Βρέθηκε 1 ασφάλεια."
		},
    getInsurances: function () {
			const vm = this;
			vm.tableRows = '';

			let formData = {
				month: this.selectedMonth + 1,
				year: this.selectedYear,
				type: this.type,
				user: JSON.parse(localStorage.getItem('sav-erp-user')),
				token: this.$cookie.get('sav-erp-token'),
				refreshToken: this.$cookie.get('sav-erp-refresh-token')
			};

			let headers = { 
				headers: {
				'Content-type': 'application/json',
				}
			};

			axios.post(this.apiUrl + '/get/calendar/' + this.type, formData, headers)
				.then(response => {
					vm.isLoading = false;
					if (response.status == 200) {
						this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
						vm.errorMsg = '';
						vm.tableRows = response.data.data;
						vm.resultNum = this.getResultHeader(this.tableRows.length);
					} else {
						vm.resultNum = '';
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
					}
				})
				.catch(function (error) {
					let response = error.response;
					vm.resultNum = '';
					
					if (response.status == 401) {
						localStorage.removeItem('user');    
						vm.$cookie.delete('sav-erp-token');
						vm.$cookie.delete('sav-erp-refresh-token');
						vm.$router.push("/login");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
					}
					vm.isLoading = false;
				});
		}
  }
}
</script>

<style lang="scss" scoped>
  @import "./../scss/_colors";
	@import "./../scss/_mq";

	.sav-calendar-search {
		margin-bottom: 30px;
	}
	
	.input-container {
		flex: 1 0 31%; /* explanation below */
		max-width: 360px;
		margin-bottom: 30px;

		&:not(:nth-child(3n)) {
        margin-right: 20px;
    }

		h3 {
			margin-top: 0;
			color: $blue;
			border-bottom: 2px solid $blue;
			font-size: 20px;
			font-weight: 500;
			margin-bottom: 15px;
		}
	}
	
	.sav-calendar-search-footer {
		display: flex;
		justify-content: flex-end;
	}

	#error-msg {
		color: $red;
		font-weight: 400;
		padding: 10px;
		margin-right: 10px;
	}

	#results-num-msg {
		color: $blue;
		font-weight: 400;
		padding: 10px;
		margin-right: 10px;
	}
</style>
